import Vue from 'vue';
import store from './../../store';

const success = (id, resolve) => {
  store.dispatch('removeChartOfAccountsItem', id);
  resolve();
};

const failed = reject => reject();

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http.delete(`/chart_of_accounts/${id}`)
      .then(() => {
        success(id, resolve);
      })
      .catch(() => {
        failed(reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/chartOfAccounts/destroy.js